module.exports = __webpack_public_path__ + "assets/img/newG03.5171047a.png";